import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const offices = [
  { city: 'Hyderabad', tag: 'Head Office', url: 'https://maps.google.com/?q=Xpert+Advisor+Study+Abroad+Head+Office+Hyderabad' },
  { city: 'Karimnagar', tag: 'Branch', url: 'https://maps.google.com/?q=Xpert+Advisor+2nd+floor+Sree+Rama+Arcade+Maitri+Convention+Kisan+Nagar+Karimnagar+505001' },
  { city: 'Visakhapatnam', tag: 'Branch', url: 'https://maps.google.com/?q=Kailash+Appartments+Siripuram+Visakhapatnam' },
  { city: 'Guntur', tag: 'Branch', url: 'https://maps.google.com/?q=Xpert+Advisor+Study+Abroad+Flat+No+3%264+Second+Floor+Singapore+Plaza+4%2F14+4th+Ln+opp+Master+Xerox+Brodipet+Guntur+Andhra+Pradesh+522002' }
];

const programs = [
  { label: 'MBBS Abroad', to: '/mbbs-abroad' },
  { label: 'PhD Admissions', to: '/phd-admissions' },
  { label: 'Nursing in Germany', to: '/nursing-in-germany' },
  { label: 'Workforce Management', to: '/workforce-management' },
  { label: 'Universities by Country', to: '/universities' }
];

const services = [
  'SOP & LOR Writing',
  'Visa Guidance',
  'Mock Interviews',
  'Post-landing Services',
  'Flight Ticket Booking'
];

const Footer = () => {
  return (
    <footer className="bg-navy-950 text-white relative overflow-hidden">
      <div className="absolute -top-32 left-1/3 w-96 h-96 rounded-full bg-brand-500/10 blur-3xl pointer-events-none"></div>

      <div className="container-x relative py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block" aria-label="Xpert Advisor home">
              {/* White card behind the logo so it reads clearly on the dark footer */}
              <span className="inline-flex items-center bg-white rounded-2xl px-4 py-3 shadow-card">
                <img
                  src="/Logo.png"
                  alt="Xpert Advisor — Rise Above Limits"
                  className="h-24 w-auto"
                />
              </span>
            </Link>
            <p className="mt-4 text-sm text-navy-100/60 leading-relaxed max-w-xs">
              Study abroad, MBBS, PhD, Nursing in Germany and workforce management —
              guided end-to-end so you can rise above limits.
            </p>
            {/* Social */}
            <div className="mt-6 flex items-center gap-2.5">
              <a
                href="https://www.facebook.com/profile.php?id=61587522251645"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 hover:bg-brand-500 rounded-full flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/xpert_advisor_official/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-white/10 hover:bg-brand-500 rounded-full flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="#"
                className="w-9 h-9 bg-white/10 hover:bg-brand-500 rounded-full flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-display text-sm font-bold tracking-[0.16em] uppercase text-navy-100/50">Programs</h4>
            <ul className="mt-5 space-y-3">
              {programs.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-navy-100/75 hover:text-brand-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-sm font-bold tracking-[0.16em] uppercase text-navy-100/50">Services</h4>
            <ul className="mt-5 space-y-3">
              {services.map((item) => (
                <li key={item}>
                  <a href="/#services" className="text-sm text-navy-100/75 hover:text-brand-400 transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Offices & contact */}
          <div>
            <h4 className="font-display text-sm font-bold tracking-[0.16em] uppercase text-navy-100/50">Find us</h4>
            <ul className="mt-5 space-y-3">
              {offices.map((office) => (
                <li key={office.city}>
                  <a
                    href={office.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center gap-2.5 text-sm text-navy-100/75 hover:text-brand-400 transition-colors"
                  >
                    <MapPin className="w-4 h-4 text-brand-400/70 group-hover:text-brand-400" />
                    {office.city}
                    <span className="text-[10px] font-semibold uppercase tracking-wider text-navy-100/40">{office.tag}</span>
                  </a>
                </li>
              ))}
              <li>
                <a href="tel:+917674099636" className="group flex items-center gap-2.5 text-sm text-navy-100/75 hover:text-brand-400 transition-colors">
                  <Phone className="w-4 h-4 text-brand-400/70 group-hover:text-brand-400" />
                  +91 76740 99636
                </a>
              </li>
              <li>
                <a href="tel:+919059333987" className="group flex items-center gap-2.5 text-sm text-navy-100/75 hover:text-brand-400 transition-colors">
                  <Phone className="w-4 h-4 text-brand-400/70 group-hover:text-brand-400" />
                  +91 90593 33987
                </a>
              </li>
              <li>
                <a href="mailto:info@xpertadvisor.in" className="group flex items-center gap-2.5 text-sm text-navy-100/75 hover:text-brand-400 transition-colors">
                  <Mail className="w-4 h-4 text-brand-400/70 group-hover:text-brand-400" />
                  info@xpertadvisor.in
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 relative">
        <div className="container-x py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-navy-100/45">
            <p>© {new Date().getFullYear()} Xpert Advisor. All rights reserved. · Rise Above Limits</p>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-brand-400 transition-colors">Privacy</a>
              <a href="#" className="hover:text-brand-400 transition-colors">Terms</a>
              <a href="#" className="hover:text-brand-400 transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
